import Handsontable from "handsontable";
import { HotHeatMapResult, HotHeatMapSingleMeta } from "..";
import { ColumnSettings } from "handsontable/settings";
import { isgCountDecimalPlaces, isgNumericLocale } from "../../functions";


/**
 * Custom renderer for a single colour heat map.
 * Dynamic heat map that - configuration implementation based on the manipulation of 'isg-hm-' classes stored in the header column name
 * 
 * 1. Transforms the cell value to a color based on the value and the max value in the column
 * 2. Retrieves the background color from a custom class name stored in the column header class name
 * 3. Caches the max value in the column header class name for future use
 *
 * @param hot The Handsontable instance.
 * @param td The table cell.
 * @param row The row index.
 * @param column The column index.
 * @param prop The property.
 * @param value The value.
 * @param cellProperties The cell properties.
 */
export function isgRendererNumeric(hot: Handsontable
  , td: any
  , row: number
  , column: number
  , prop: any
  , value: any
  , cellProperties: any) {

  let colItem: ColumnSettings = hot.getColumnMeta(column);
  let decimalPlaces: number = 2;

  // See if we have a number format that should be applied
  if (colItem.numericFormat?.pattern) {
    decimalPlaces = isgCountDecimalPlaces(colItem.numericFormat.pattern.toString());
  }

  td.classList.remove('htInvalid');

  if (value != null && !isNaN(value)) {

    td.classList.add('htRight');

    // retain any callback styling
    if (cellProperties.className && cellProperties.className.length > 0) {
      td.classList.add(cellProperties.className);
    }

    td.innerHTML = isgNumericLocale(value, decimalPlaces);
  }
  else if (isgIsNonNumericText(value)) {

    // Text in a numeric column is shown and flagged so the user can see and fix it
    td.classList.add('htRight');
    td.classList.add('htInvalid');
    td.textContent = value;
  }
  else {
    td.innerHTML = "";
  }
}

/** Non-empty text that is not a number, e.g. 'a' typed or pasted into a numeric cell */
function isgIsNonNumericText(value: any): boolean {

  return typeof value === 'string'
    && value.trim() !== '';
}
